import { v4 as uuidv4 } from 'uuid';
import { forwardRef } from 'react';

import type { InputProps } from './Input.d';
import { INPUT_CONST } from './Input.d';
import { Input } from './Input.styles';

const InputBase = forwardRef(
  (
    {
      error,
      ghost,
      id: customId,
      renderPrefix,
      renderSuffix,
      success,
      type = 'text',
      value,
      ...props
    }: InputProps,
    ref: InputProps['ref'],
  ) => {
    const id = customId || `input_${uuidv4()}`;

    const prefix = renderPrefix && <Input.Prefix>{renderPrefix}</Input.Prefix>;
    const suffix = renderSuffix && <Input.Suffix>{renderSuffix}</Input.Suffix>;

    const hasPrefix = !!prefix;
    const hasSuffix = !!suffix;

    return (
      <Input.Label data-testid={INPUT_CONST.TEST_ID} htmlFor={id}>
        {prefix}
        <Input.Input
          ref={ref}
          data-error={error}
          data-ghost={ghost}
          data-hasprefix={hasPrefix}
          data-hassuffix={hasSuffix}
          data-success={success}
          id={id}
          type={type}
          value={value}
          {...props}
        />
        {suffix}
      </Input.Label>
    );
  },
);
InputBase.displayName = 'InputBase';
export default InputBase;
